import type { HttpCore } from '../http';

/** Mirrors `environmentApi` in `frontend/web-ide/src/services/api.ts`. */
export function createEnvironmentsModule(core: HttpCore) {
  return {
    create: (data: Record<string, unknown>) => core.request<unknown>('/environments', { method: 'POST', body: data }),
    list: (userId: string) => core.request<unknown>(`/environments/${userId}`),
    get: (userId: string, environmentId: string) => core.request<unknown>(`/environments/${userId}/${environmentId}`),
    delete: (userId: string, environmentId: string) =>
      core.request<unknown>(`/environments/${userId}/${environmentId}`, { method: 'DELETE' }),
    start: (userId: string, environmentId: string) =>
      core.request<unknown>(`/environments/${userId}/${environmentId}/start`, { method: 'POST' }),
    stop: (userId: string, environmentId: string) =>
      core.request<unknown>(`/environments/${userId}/${environmentId}/stop`, { method: 'POST' }),
    restart: (userId: string, environmentId: string) =>
      core.request<unknown>(`/environments/${userId}/${environmentId}/restart`, { method: 'POST' }),
    logs: (userId: string, environmentId: string, lines?: number) =>
      core.request<unknown>(`/environments/${userId}/${environmentId}/logs`, { params: { lines } }),
    exec: (userId: string, environmentId: string, command: string[]) =>
      core.request<unknown>(`/environments/${userId}/${environmentId}/exec`, { method: 'POST', body: { command } }),
  };
}

export type EnvironmentsModule = ReturnType<typeof createEnvironmentsModule>;
